import React from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import * as R from 'ramda';

import { Container } from 'components/shared/container/Container.styled';
import { SectionFlattenProps } from '../section/Section.props';
import { translate } from 'shared/utils/translate';
import { H3, ParagraphRegular } from 'components/shared/typography';
import * as Styled from './TextNextToImage.styled';

const TextNextToImage = ({
  components = [],
  direction,
  theme,
  intl,
}: WrappedComponentProps & SectionFlattenProps) => {
  const component = components[0];

  if (!component) return null;

  const { title, body, imageUrl } = component;
  const url = imageUrl || '';
  const color = theme?.color || '';

  return (
    <Container size="md">
      <Styled.Wrapper direction={direction || 'row'}>
        {url && <Styled.Image url={url} />}
        <Styled.Description>
          {title && (
            <Styled.TitleWrapper>
              <H3 color={color}>{translate({ intl, id: title })}</H3>
            </Styled.TitleWrapper>
          )}
          {body && (
            <ParagraphRegular color={color}>
              {translate({ intl, id: body })}
            </ParagraphRegular>
          )}
        </Styled.Description>
      </Styled.Wrapper>
    </Container>
  );
};

export default injectIntl(TextNextToImage);
